var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"root-tx-button",class:{
    'mode-modern': _vm.mode === 'modern',
    'uppercase': _vm.textUppercase,
    'disabled': _vm.disabled,
    'no-hover': _vm.noHover,
    'full-width': _vm.fullWidth
  },attrs:{"type":_vm.type,"disabled":_vm.disabled,"loading":_vm.loading},on:{"click":function (e) { return _vm.$emit('click', e); }}},[_c('div',{staticClass:"tx-button"},[_c('div',{staticClass:"content"},[(_vm.loading)?_c('div',{staticClass:"loading-container"},[_c('v-progress-circular',{attrs:{"width":3,"color":"white","indeterminate":""}})],1):_vm._e(),_c('div',{class:{'hide': _vm.loading}},[_vm._t("default")],2)])])])}
var staticRenderFns = []

export { render, staticRenderFns }